import { React, useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import UseProfileData from '../plugin/UseProfileData'
import apiInstance from '../../utils/axios';
import UserData from '../plugin/UserData';

function Sidebar() {
    const userProfile = UseProfileData()
    const userData = UserData()
    let [loading, setLoading] = useState(true);
    const [notificationCount, setNotificationCount] = useState(0);
    const [orderCount, setOrderCount] = useState(0);
    const [wishlistCount, setWishlistCount] = useState(0);

    useEffect(() => {
        if (userProfile) {
            setLoading(false)
        }
    })

    // Fetch real-time counts
    useEffect(() => {
        if (userData?.user_id) {
            // Fetch notification count
            apiInstance.get(`customer/notification/${userData.user_id}/`)
                .then((res) => {
                    setNotificationCount(res.data.length);
                })
                .catch((error) => {
                    console.error('Error fetching notifications:', error);
                });

            // Fetch order count
            apiInstance.get(`customer/orders/${userData.user_id}/`)
                .then((res) => {
                    setOrderCount(res.data.length);
                })
                .catch((error) => {
                    console.error('Error fetching orders:', error);
                });

            // Fetch wishlist count
            apiInstance.get(`customer/wishlist/${userData.user_id}/`)
                .then((res) => {
                    setWishlistCount(res.data.length);
                })
                .catch((error) => {
                    console.error('Error fetching wishlist:', error);
                });
        }
    }, [userData?.user_id]);

    return (
        <div className="col-lg-3 col-md-12 mb-4 mb-lg-0 customer-dashboard">
            {loading === false &&
                <>
                    {/* Profile Card */}
                    <div className="card sidebar-card border-0 shadow-sm mb-4 depth-2">
                        <div className="card-body text-center p-4">
                            <div className="position-relative mb-3 profile-image">
                                <img
                                    src={userProfile?.image}
                                    style={{ 
                                        width: "80px", 
                                        height: "80px", 
                                        borderRadius: "50%", 
                                        objectFit: "cover", 
                                        border: "4px solid #f8f9fa" 
                                    }}
                                    alt="Perfil"
                                    className="img-fluid"
                                />
                                <div className="profile-status"></div>
                            </div>
                            <h5 className="mb-2 text-dark fw-semibold">{userProfile?.full_name}</h5>
                            <div className="d-flex flex-column flex-sm-row gap-2 justify-content-center">
                                <Link to="/customer/settings/" className="btn btn-outline-primary btn-sm">
                                    <i className='fas fa-edit me-2'></i> Editar Cuenta
                                </Link>
                                <button 
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={() => window.location.reload()}
                                    title="Actualizar datos"
                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Navigation Menu */}
                    <div className="card sidebar-card border-0 shadow-sm depth-2">
                        <div className="card-body p-0">
                            <div className="list-group list-group-flush">
                                <Link to={'/customer/account/'} className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#e3f2fd", borderRadius: "8px" }}>
                                        <i className='fas fa-user text-primary'></i>
                                    </div>
                                    <span className="fw-semibold text-dark">Cuenta</span>
                                </Link>
                                
                                <Link to={'/customer/orders/'} className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center justify-content-between py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#e8f5e8", borderRadius: "8px" }}>
                                            <i className='fas fa-shopping-cart text-success'></i>
                                        </div>
                                        <span className="fw-semibold text-dark">Pedidos</span>
                                    </div>
                                    {orderCount > 0 && (
                                        <span className="badge bg-primary rounded-pill">{orderCount}</span>
                                    )}
                                </Link>
                                
                                <Link to={'/customer/wishlist/'} className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center justify-content-between py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#fce4ec", borderRadius: "8px" }}>
                                            <i className='fas fa-heart text-danger'></i>
                                        </div>
                                        <span className="fw-semibold text-dark">Lista de Deseos</span>
                                    </div>
                                    {wishlistCount > 0 && (
                                        <span className="badge bg-primary rounded-pill">{wishlistCount}</span>
                                    )}
                                </Link>
                                
                                <Link to={'/customer/notifications/'} className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center justify-content-between py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#fff3e0", borderRadius: "8px" }}>
                                            <i className='fas fa-bell text-warning'></i>
                                        </div>
                                        <span className="fw-semibold text-dark">Notificaciones</span>
                                    </div>
                                    {notificationCount > 0 && (
                                        <span className="badge bg-danger rounded-pill">{notificationCount}</span>
                                    )}
                                </Link>
                                
                                <Link to={'/customer/settings/'} className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#f3e5f5", borderRadius: "8px" }}>
                                        <i className='fas fa-gear text-purple'></i>
                                    </div>
                                    <span className="fw-semibold text-dark">Configuración</span>
                                </Link>
                                
                                <div className="border-top my-2"></div>
                                
                                <Link to="/logout" className="list-group-item sidebar-item list-group-item-action border-0 d-flex align-items-center py-3 px-4 text-decoration-none">
                                    <div className="d-flex align-items-center justify-content-center me-3" style={{ width: "40px", height: "40px", backgroundColor: "#ffebee", borderRadius: "8px" }}>
                                        <i className='fas fa-sign-out-alt text-danger'></i>
                                    </div>
                                    <span className="fw-semibold text-danger">Cerrar Sesión</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Quick Stats for Mobile */}
                    <div className="d-md-none mt-4 mobile-stats">
                        <div className="row g-2">
                            <div className="col-4">
                                <div className="card border-0 shadow-sm text-center py-3 depth-1">
                                    <div className="small text-muted mb-1">Pedidos</div>
                                    <div className="fw-bold text-primary">{orderCount}</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="card border-0 shadow-sm text-center py-3 depth-1">
                                    <div className="small text-muted mb-1">Lista de Deseos</div>
                                    <div className="fw-bold text-danger">{wishlistCount}</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="card border-0 shadow-sm text-center py-3 depth-1">
                                    <div className="small text-muted mb-1">Alertas</div>
                                    <div className="fw-bold text-warning">{notificationCount}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    )
}

export default Sidebar